"use client";

import { usePathname } from "next/navigation";
import { getPageSchemas } from "../lib/seo/schema-router";

export default function SchemaInjector() {
  const pathname = usePathname();
  
  // Get appropriate schemas for current page
  const schemas = getPageSchemas({ pathname });
  
  // Don't render anything if no schemas
  if (!schemas || schemas.length === 0) {
    return null;
  }
  
  return (
    <>
      {schemas.map((schema, index) => (
        <script
          key={`schema-${index}-${pathname}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(schema),
          }}
        />
      ))}
    </>
  );
}